<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="p-breadcrumb">
        <ul class="p-breadcrumb-list">
          <li class="p-breadcrumb-list__item">
            <a href="/coins-admin/cart/result-list">カートプッシュの成果一覧</a>
          </li>
          <li class="p-breadcrumb-list__item">
            <a :href="'/coins-admin/cart/result-message-list/' + summaryDate">{{ summaryDate }}</a>
          </li>
          <li class="p-breadcrumb-list__item">{{ summaryMessage.message.message_name }}</li>
        </ul>
      </div>
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">カートプッシュの成果</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          メッセージ詳細<br />
          プッシュ名：{{ messageName }}<br />
          配信種別：{{ deliverType }}<br />
          配信開始日時：{{ startTime }}<br />
          配信終了日時： {{ endTime}}<br />
          状態：{{ deliverStatus }}<br />
          <div class="p-message-result__data">

            <div class="p-message-select-condition-list-type">
              <div class="c-tab">
                <ul class="c-tab-list">
                  <li
                    class="c-tab-list__item"
                    :class="tab == 1 ? 'is-active' : ''"
                    data-type="device"
                    @click="onDeviceTabClick"
                  >
                    デバイス別集計
                  </li>
                  <li
                    class="c-tab-list__item"
                    :class="tab == 2 ? 'is-active' : ''"
                    data-type="os"
                    @click="onOsTabClick"
                  >
                    OS別集計
                  </li>
                  <!-- <li
                                    class="c-tab-list__item"
                                    v-bind:class="tab == 3 ? 'is-active' : ''"
                                    data-type="url"
                                    @click="onUrlTabClick"
                                >
                                    URL別集計
                                </li> -->
                </ul>
              </div>
            </div>


            <div v-show="tab == 1" class="p-condition-result">
              <div class="p-condition-result__data">
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160 is-sortable">
                        <span class="c-table__text">デバイス別</span>
                      </th>
                      <th class="c-table__cell--center u-w136 is-sortable">
                        <span class="c-table__text">表示数</span>
                      </th>
                      <th class="c-table__cell--center u-w290 is-sortable">
                        <span class="c-table__text">クリック数</span>
                      </th>
                      <th class="c-table__cell--center is-sortable">
                        <span class="c-table__text">CTR</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="is-editable">
                    <tr v-for="(summaryDevice,index) in summaryMessage.summary_devices" :key="index">
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getDeviceName(summaryDevice.device_name) }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryDevice.display_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryDevice.click_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(summaryDevice.click_count,summaryDevice.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-show="tab == 2" class="p-condition-result">
              <div class="p-condition-result__data">
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160 is-sortable">
                        <span class="c-table__text">OS別</span>
                      </th>
                      <th class="c-table__cell--center u-w136 is-sortable">
                        <span class="c-table__text">表示数</span>
                      </th>
                      <th class="c-table__cell--center u-w290 is-sortable">
                        <span class="c-table__text">クリック数</span>
                      </th>
                      <th class="c-table__cell--center is-sortable">
                        <span class="c-table__text">CTR</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="is-editable">
                    <tr v-for="(summaryOs,index) in summaryMessage.summary_oses" :key="index">
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryOs.os_name }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryOs.display_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryOs.click_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(summaryOs.click_count,summaryOs.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-show="tab == 3" class="p-condition-result">
              <div class="p-condition-result__data">
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160 is-sortable">
                        <span class="c-table__text">URL別</span>
                      </th>
                      <th class="c-table__cell--center u-w136 is-sortable">
                        <span class="c-table__text">表示数</span>
                      </th>
                      <th class="c-table__cell--center u-w290 is-sortable">
                        <span class="c-table__text">クリック数</span>
                      </th>
                      <th class="c-table__cell--center is-sortable">
                        <span class="c-table__text">CTR</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="is-editable">
                    <tr v-for="(summaryUrl,index) in summaryMessage.summary_urls" :key="index">
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryUrl.referrer_url }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryUrl.display_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ summaryUrl.click_count }}
                      </td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(summaryUrl.click_count,summaryUrl.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
/**
 * カートプッシュの成果メッセージ詳細ページ
 *
 * 仕様変更 (2025-10-06):
 * - 以前は periodType プロパティを受け取り、パンくずリストのURLに含めていた
 * - 仕様変更により periodType を廃止
 * - ルート定義も /cart/result-message-list/{summaryDate} に変更
 */
export default {
  props: {
    summaryInfo: Object,
    summaryMessage: Object,
    summaryDate: String,
    // 仕様変更: periodType プロパティを廃止
  },
  data () {
    return {
      tab: 1,

      // フラグ系
      isError: false,
      errorMessage: '',
    }
  },
  computed: {
    messageName: function () {
      let messageName = "-";
      if(this.summaryMessage && this.summaryMessage.message && this.summaryMessage.message.message_name){
        messageName = this.summaryMessage.message.message_name;
      }
      return messageName;
    },
    deliverStatus: function () {
      let deliverStatus = "-";
      if(this.summaryMessage && this.summaryMessage.message){
        deliverStatus =
          this.summaryMessage.message.deliver_status == 30
            ? '配信中'
            : this.summaryInfo.deliverStatuses[
              this.summaryMessage.message.deliver_status
            ];
      }
      return deliverStatus;
    },
    deliverType: function () {
      let deliverType = "-";
      if(this.summaryMessage && this.summaryMessage.message && this.summaryMessage.message.message_deliver){
        deliverType = this.summaryInfo.deliverTypes[this.summaryMessage.message.message_deliver.deliver_type];
      }
      return deliverType;
    },
    startTime: function () {
      let startTime = "-";
      if(this.summaryMessage && this.summaryMessage.message &&
        this.summaryMessage.message.message_deliver && this.summaryMessage.message.message_deliver.send_start_date){
        startTime = this.summaryMessage.message.message_deliver.send_start_date;
      }
      return startTime;
    },
    endTime: function () {
      let endTime = "-";
      if(this.summaryMessage && this.summaryMessage.message &&
        this.summaryMessage.message.message_deliver && this.summaryMessage.message.message_deliver.send_end_date){
        endTime = this.summaryInfo.deliverTypes[this.summaryMessage.message.message_deliver.send_end_date];
      }
      return endTime;
    },
  },
  mounted: function() {
    import('../../funcs/pages/message').then(module => {
      module.Message();
    });
  },
  methods: {
    getDeviceName: function(deviceValue) {
      return this.summaryInfo.deviceTypes[deviceValue];
    },
    getCtr: function(clickCount,displayCount) {
      let ctrString = '0.00%';
      if(displayCount > 0 && clickCount > 0){
        let ctr = clickCount * 100 / displayCount;
        ctrString = ctr.toFixed(2) + '%';
      }
      return ctrString;
    },
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    onDeviceTabClick: function() {
      this.tab = 1;
    },
    onOsTabClick: function() {
      this.tab = 2;
    },
    onUrlTabClick: function() {
      this.tab = 3;
    },

  }
}
</script>
